import { Box, Typography, useTheme } from "@mui/material";
import { Button } from "@/components/Button";

import React, { useEffect, useRef } from "react";

import SaleSvg from "@/assets/svgs/sale.svg?react";
import { Toast } from "@/components/core/Toast";
import { logger } from "@/core/logger";
import { HeapService } from "@/services/heap";
import { useMonitoringRetention } from "@/hooks/legalProceedings/useMonitoringRetention";
import { useReactivateMonitoring } from "@/hooks/legalProceedings/useReactivateMonitoring";

/**
 * One-click prompt shown when the plan is back to ACTIVE after monitoring was
 * previously paused. Reactivates Judit monitoring for the tracked processes.
 */
export const ReactivateMonitoringBanner = () => {
  const theme = useTheme();
  const { showReactivatePrompt, monitoredCount, clearWasPausedFlag } = useMonitoringRetention();
  const { mutateAsync: reactivateMonitoring, isPending } = useReactivateMonitoring();

  const impressionTracked = useRef(false);
  useEffect(() => {
    if (showReactivatePrompt && !impressionTracked.current) {
      impressionTracked.current = true;
      HeapService.track("Reativar Monitoramento Exibido", { monitoredCount });
    }
  }, [showReactivatePrompt, monitoredCount]);

  const handleReactivate = async () => {
    HeapService.track("Reativar Monitoramento Clicado", { monitoredCount });
    try {
      await reactivateMonitoring();
      clearWasPausedFlag();
      Toast.success("Monitoramento reativado com sucesso!");
    } catch (err) {
      logger.error("handleReactivateMonitoring", { error: err });
      Toast.error("Ocorreu um erro ao reativar o monitoramento. Tente novamente mais tarde.");
    }
  };

  if (!showReactivatePrompt) return null;

  return (
    <Box
      sx={{
        backgroundColor: "secondary.main",
        padding: "8px 16px 8px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1,
        [theme.breakpoints.down("md")]: {
          display: "none",
        },
      }}
    >
      <Typography
        color="common.black"
        sx={{
          display: "flex",
          gap: 1,
          py: 0.25,
        }}
      >
        <SaleSvg
          style={{
            margin: "auto 0 auto 0",
          }}
        />
        <Typography
          sx={{
            fontWeight: 700,
            "@media (max-width: 960px)": {
              height: "auto",
            },
          }}
          color="common.black"
        >
          Reativar monitoramento de {monitoredCount} {monitoredCount === 1 ? "processo" : "processos"}
        </Typography>
      </Typography>
      <Button
        sx={{
          width: "max-content",
          borderRadius: "20px",
          lineHeight: "22px",
          paddingY: 0.5,
          alignSelf: "center",
        }}
        variant="contained"
        onClick={handleReactivate}
        disabled={isPending}
        isLoading={isPending}
        loaderStyle={{ maxWidth: "233px", borderRadius: "20px", height: "30px" }}
      >
        Reativar monitoramento
      </Button>
    </Box>
  );
};
